import styles from "./blogcard.module.css";
import { Image } from "../../shared/index";
import { FaRegUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const BlogCard = ({ blog }) => {
  const { desc, imageUrl,title } = blog;
    const navigate = useNavigate();

  return (
    <div className={styles.blog__card}>
      <Image
        src={imageUrl}
        alt={desc}
        className={styles.blog__card__image}
      />

      <div className={styles.blog__content}>
        <div className={styles.blog__author}>
          <FaRegUser className={styles.user__icon} />
          <span>By Admin</span>
        </div>

        <h3 className={styles.blog__title}>{desc}</h3>

        <p className={styles.blog__desc}>
         {title}
        </p>

         <button
      className={styles.blog__btn}
      onClick={() => navigate("/shop")}
    >
      READ MORE
    </button>
      </div>
    </div>
  );
};

export default BlogCard;